// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f05c4c2","361":"cb6f7403","455":"8a2d3fb7","970":"6de31d9f","977":"0216a576"}[chunkId] + ".chunk.js";
};